import React from 'react';
import { type ServerUiComponent } from '@features/server-ui';
import { Skeleton } from '@mui/material';

/**
 * Shared metric-tile height. The grid floor, the below-gate ghost, the page
 * skeleton, and the per-tile lazy placeholder all use it so every tile is the
 * same size and lazy content loads in without layout shift.
 */
export const TILE_MIN_HEIGHT = 260;

/**
 * Tile-sized loading placeholder. Registered as the lazy skeleton on the
 * semantic ServerUiDomainProvider (hence the ignored optional `component`
 * prop) and reused as the dashboard/home grid skeleton — one source of truth
 * for the reserved height, so the real tile drops in without shifting layout.
 */
export const TileSkeleton: React.FC<{ component?: ServerUiComponent }> = () => (
  <Skeleton variant="rounded" sx={{ height: TILE_MIN_HEIGHT, borderRadius: 2.5 }} />
);
